import styled from 'styled-components'

export const Empty = styled.p`
	margin-top: 8px;
`
